// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"67d62a8e","163":"67d62a8e","428":"271b5721"}[chunkId] + ".chunk.css";
};